<template>
    <span>

        <base-button v-if="isPartnerAccount" size="sm" class="btn-dark" :disabled="(textDisabled && drawDisabled && uploadDisabled && certificateDisabled) || !isPinVerified || isBalancePending || formIncomplete || isViewOnly" data-backdrop="static"
            data-keyboard=false data-toggle="modal" data-target="signatureModal" @click.native="viewItem">
            {{module == 'transactionComplete' ? 'Completion Document' : 'Sign'}}
        </base-button>
        <!-- finance signature validation added -->
         <base-button v-else size="sm" class="btn-dark" :disabled="textDisabled && drawDisabled && uploadDisabled && certificateDisabled || isBalancePending || billedStatus || formIncomplete || isViewOnly" data-backdrop="static"
            data-keyboard=false data-toggle="modal" data-target="signatureModal" @click.native="viewItem">
            {{module == 'transactionComplete' ? 'Completion Document' : 'Sign'}}
        </base-button>


        <modal style="z-index: 10;" v-on:close="close" :show.sync="modals.classic" modal-id="signatureModal" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">{{ headerText }}</h4>
            <el-tabs v-model="activeName" @tab-click="tab_clicked">
                <el-tab-pane  v-if="module != 'transactionComplete' " name="TEXT" :disabled="textDisabled">
                    <span slot="label">
                        <i class="tim-icons icon-paper block"></i> Text
                    </span>

                    <alert-signature-text 
                    :hasSignature="signatureData.signatureId"
                        ref="TEXT" 
                        :input="signatureData.text" 
                        :font="signatureData.fontFamily"
                        v-bind:isPartnerAccount="isPartnerAccount"
                        v-on:onTextResult="onTextResult" />
                </el-tab-pane>

                <el-tab-pane 
                v-if="module != 'transactionComplete' "
                
                name="DRAW" :disabled="drawDisabled">
                    <span slot="label">
                        <i class="tim-icons icon-paper block"></i> Draw 
                    </span>

                    <alert-signature-draw ref="DRAW" 
                        :drawData="signatureData.type == 'DRAW' ? signatureData.edit : ''"
                        :hasSignature="signatureData.signatureId"
                        v-on:onDrawResult="onDrawResult" />
                </el-tab-pane>

                <el-tab-pane name="UPLOAD" :disabled="uploadDisabled">
                    <span slot="label">
                        <i class="tim-icons icon-paper block"></i> Upload
                    </span>

                    <alert-signature-upload ref="UPLOAD" :module="'transactionComplete'"  :fileTypeId="fileTypeId" v-on:onUploadResult="onUploadResult" />

                </el-tab-pane>

                <el-tab-pane  v-if="module != 'transactionComplete' " name="CERTIFICATE" :disabled="certificateDisabled">
                    <span slot="label">
                        <i class="tim-icons icon-paper block"></i> CAC
                    </span>

                    <alert-signature-certificate ref="CERTIFICATE" 
                        :drawData="signatureData.type == 'CERTIFICATE' ? signatureData.edit : ''"
                        :id="signatureData.signatureId"
                        v-on:onCertResult="onCertResult" />
                </el-tab-pane>
            </el-tabs>
        </modal>
    </span>
</template>

<script>
import Utility from "@/mixins/utility/utility";
import { Tabs, TabPane } from "element-ui";
import { Modal } from "@/components";
import AlertSignatureDraw from "@/components/App/signatures/create/Draw.vue";
import AlertSignatureText from "@/components/App/signatures/create/Text.vue";
import AlertSignatureUpload from "@/components/App/signatures/create/Upload.vue";
import AlertSignatureCertificate from "@/components/App/signatures/create/Certificate.vue";
import {mapGetters , mapActions} from 'vuex'
export default {
    name: "AlertSignature",
    components: {
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        Modal,
        AlertSignatureDraw,
        AlertSignatureText,
        AlertSignatureUpload,
        AlertSignatureCertificate,
    },
    mixins: [Utility],
    props: {
        headerText: {
            type: String,
            default: "",
        },
        module: {
            type: String,
            default: "",
        },
        action: {
            type: String,
            default: "",
        },
        activeTab: {
            type: String,
            default: "TEXT",
        },
        signatureData: {
            type: Object,
            //default: () => { }
        },
        fileTypeId: {
            type: Number,
            default: 0,
        },
        textDisabled: {
            type: Boolean,
            default: false
        },
        drawDisabled: {
            type: Boolean,
            default: false
        },
        uploadDisabled: {
            type: Boolean,
            default: false
        },
         isPinVerified: {
            type: Boolean,
            default: true
        },
       
        certificateDisabled: {
            type: Boolean,
            default: false
        },
        isBalancePending: {
            type: Boolean,
            default: false
        },
        formIncomplete:{
            type: Boolean,
            default: false
        }
      
    },
    data() {
        return {
            activeName: 'TEXT',

            tabs: {
                0: "TEXT",
                1: "DRAW",
                2: "UPLOAD",
                3: "CERTIFICATE",
            },
            modals: {
                classic: false,
            },
        }
    },
    computed: {
        ...mapGetters({
      isPartnerAccount: "authentication/isPartnerAccount",
      orderStatus: "orderMetadata/orderStatus",
      disbursingCollectionInformationStatus:
      "disbursingCollectionInformation/disbursingCollectionInformationStatus",
      }),
      billedStatus(){
        if(this.module == "financialRepresentative"){
            if(this.orderStatus == "BILLED" && this.disbursingCollectionInformationStatus){
                return false
            }else{
                return true
            }
      }else{
        return false
      }
    },
      isViewOnly() {
        return this.$route.path.includes('/view/');
      }
    },
    methods: {
        ...mapActions({
              getDocuments: "documents/getDocuments",
        }),
        tab_clicked: function (tab, event) {
            let ref = this.$refs[this.tabs[tab.index]]
           
                return ref.load();
        },
        viewItem() {
            this.activeName = this.activeTab;

            let ref = this.$refs[this.activeName];

                ref.load();

            this.modals.classic = true;

        },
        close() {
            this.modals.classic = false;
            this.$emit('modal-closed');
        },
        clearSignaturePad() {
            // Clear all signature types (TEXT, DRAW, UPLOAD, CERTIFICATE)
            if (this.$refs.TEXT) {
                this.$refs.TEXT.clear();
            }
            if (this.$refs.DRAW) {
                this.$refs.DRAW.clear();
            }
            if (this.$refs.UPLOAD) {
                this.$refs.UPLOAD.clear();
            }
            if (this.$refs.CERTIFICATE) {
                this.$refs.CERTIFICATE.clear();
            }
        },
        onDrawResult(data) {
            
            this.$loaderApp.addRequest();
            this.$store.dispatch(`${this.module}/setSignature`, { type: "DRAW", text: null, fontFamily: null, edit: data.edit, view: data.view });
            this.$loaderApp.completeRequest();
            this.close();
            this.$emit('onSigned');

        },
        onCertResult(data) {
             this.$loaderApp.addRequest();
            this.$store.dispatch(`${this.module}/setSignature`, { type: "CERTIFICATE", text: null, fontFamily: null, edit: data.edit, view: data.view });
            this.$loaderApp.completeRequest();
            this.close();
            this.$emit('onSigned');
        },
        onTextResult(data) {
            this.$loaderApp.addRequest();
            this.$store.dispatch(`${this.module}/setSignature`, { type: "TEXT", text: data.text, fontFamily: data.font, edit: null, view: data.view });
            this.$loaderApp.completeRequest();
            this.close();
            this.$emit('onSigned');
        },
        onUploadResult(data) {
            // UPLOAD type: date is NOT auto-set — backend handles signature via document
            this.$store.dispatch(`${this.module}/setSignature`, { type: "UPLOAD", text: null, fontFamily: null, edit: null, view: null });
            if(this.module != "transactionComplete"){
            this.close();
            this.$emit('onUpload')
            this.$loaderApp.completeRequest();
            }else{
            this.close();
            this.$emit('onUpload') 
            this.$loaderApp.completeRequest();
            this.getDocuments(this.$route.params.id);
            this.$toast.success("File Uploaded");

            }
        },
    }
}
</script>

<style scopped>
@import "../../../styles/custom_alert.css";

/* User Profile Modal */
@media (min-width: 576px) {
    .modal.show>.modal-dialog {
        max-width: 800px !important;
        margin: 1.75rem auto;
    }
}
</style>
